import { render } from "./FacilityRequisitionDetailsPage.vue?vue&type=template&id=fdf9a372"
import script from "./FacilityRequisitionDetailsPage.vue?vue&type=script&lang=js"
export * from "./FacilityRequisitionDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__